module.exports = __webpack_public_path__ + "static/media/redcircle2@2x.204e6109.png";